export enum MeetingStatus {
	Waiting = 'Waiting',
	InProgress = 'InProgress',
	NotStarted = 'NotStarted',
	Inactive = 'Inactive',
}
